import ArrowBack from '@mui/icons-material/ArrowBack'
import ArrowForward from '@mui/icons-material/ArrowForward'
import { Box, Button, Pagination } from '@mui/material'

interface CursorPaginatorProps {
  currentPage: number
  // How many pages have been read so far. Grows as Next pulls more in.
  loadedPageCount: number
  hasPreviousPage: boolean
  hasNextPage: boolean
  disabled?: boolean
  onPrevious: () => void
  onNext: () => void
  onPageChange: (page: number) => void
}

/**
 * CursorPaginator steps through a result set that is paged by an opaque token. The upstream
 * reports no total, so only the pages read so far are numbered and can be jumped to; Next is
 * what reaches past them.
 */
export const CursorPaginator: React.FC<CursorPaginatorProps> = ({
  currentPage,
  loadedPageCount,
  hasPreviousPage,
  hasNextPage,
  disabled,
  onPrevious,
  onNext,
  onPageChange,
}) => {
  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Button
        size="small"
        startIcon={<ArrowBack />}
        disabled={!hasPreviousPage}
        onClick={onPrevious}
      >
        Previous
      </Button>
      <Pagination
        page={currentPage}
        count={Math.max(loadedPageCount, currentPage)}
        shape="rounded"
        hidePrevButton
        hideNextButton
        disabled={disabled}
        onChange={(_, page) => onPageChange(page)}
      />
      <Button size="small" endIcon={<ArrowForward />} disabled={!hasNextPage} onClick={onNext}>
        Next
      </Button>
    </Box>
  )
}
